import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { StockHistoryLineType, stockQuantityType } from '@kinderlabs-pos/shared-data-type';

export const disposalStockQtyAsync =
	(rootUrl: string) =>
	async ({ warehouseId, data }: { warehouseId: number; data: DisposalStockQtyType[] }) =>
		(
			await posAxiosClient.put(`${rootUrl}/stock/quantity/disposal`, data, {
				params: {
					warehouseId,
				},
			})
		).data;

type DisposalStockQtyType = Omit<StockHistoryLineType, 'id' | 'createdTime' | 'stockQuantity'> & {
	stockQuantity: stockQuantityType & { totalQuantity: number };
};
